export default __webpack_public_path__ + "static/media/icon-stop-label.010935ac.svg";